<template>
    <v-app pb-3>
        <v-content>
            <v-container
                style="max-width: 1240px; padding-top: 100px; padding-bottom: 0;"
                class="header-part"
            >

                <v-layout class="header-part__title">
                    <v-flex xs12 py-2>
                        <a href="/list" class="header-link">Страховые продукты</a>
                        <h1>Расчет стоимости Антиклещ</h1>
                    </v-flex>
                </v-layout>

            </v-container>

            <v-form ref="form" v-model="valid">
                <v-container
                    style="max-width: 1240px; padding-left: 30px; padding-right: 30px; padding-bottom: 0;"
                >

                    <v-layout>
                        <v-flex xs12>
                            <h2>Застрахованные</h2>
                        </v-flex>
                    </v-layout>

                </v-container>

                <v-container
                    style="max-width: 1240px; padding-left: 30px; padding-right: 30px; padding-bottom: 50px; border-bottom: 1px solid #cecece;"
                    v-for="(insuredPerson, key) in insuredPersons" :key="insuredPerson.n"
                >
                    <v-layout>
                        <v-flex xs12 pt-4 pb-0>
                            <h3 v-if="insuredPerson.isPolicyHolder">Застрахованный {{ insuredPerson.n }} (Страхователь)</h3>
                            <h3 v-if="!insuredPerson.isPolicyHolder">Застрахованный {{ insuredPerson.n }}</h3>
                        </v-flex>
                    </v-layout>

<!--                    <v-layout row wrap>
                        <v-flex xs12 sm4 py-0>
                            <v-checkbox
                                label="Является страхователем"
                                v-model="insuredPerson.isPolicyHolder"
                                @change="insuredPersonsIsPolicyHolderChange(insuredPerson)"
                                class="pb-0"
                            />
                        </v-flex>
                    </v-layout>-->

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-checkbox
                                label="Является страхователем"
                                v-model="insuredPerson.isPolicyHolder"
                                @change="insuredPersonsIsPolicyHolderChange(insuredPerson)"
                                class="pb-0"
                                :id="`checkbox-insurer-${insuredPerson.n}-is-policyholder`"
                            />
                            <osago-name
                                v-model="insuredPerson.lastName"
                                label="Фамилия"
                                :id="`input-insurer-${insuredPerson.n}-lastname`"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="insuredPerson.firstName"
                                label="Имя"
                                :id="`input-insurer-${insuredPerson.n}-firstname`"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="insuredPerson.middleName"
                                label="Отчество"
                                optional="true"
                                :noField.sync="insuredPerson.noMiddleName"
                                genitiveLabel="отчества"
                                @change="setGender(insuredPerson)"
                                :id="`input-insurer-${insuredPerson.n}-middlename`"
                            />
                            <osago-gender
                                v-if="insuredPerson.noMiddleName"
                                v-model="insuredPerson.sex"
                                label="Пол"
                                :noField.sync="insuredPerson.sex"
                                :id="`select-insurer-${insuredPerson.n}-no-middlename`"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="insuredPerson.birthDate"
                                label="Дата рождения"
                                :max="insurerMaxBirthdayDate"
                                @change="insuredPerson.datePersonPassport = getDatePersonPassport(insuredPerson)"
                                :isHideMobile="true"
                                :id="`input-insurer-${insuredPerson.n}-birth-date`"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout
                        row wrap pt-1
                        v-if="insuredPerson.isPolicyHolder"
                    >
                        <v-flex xs12 sm6 md3 lg2 py-0>
                            <h4 style="display: inline">Паспорт</h4>

                            <v-text-field
                                v-model="insuredPerson.document.seriesNumber"
                                :rules="[rules.required, rules.passport]"
                                @paste="removeSpacesOnPaste($event, insuredPerson.document.seriesNumber)"
                                label="Серия и номер"
                                mask="#### ######"
                                return-masked-value
                                validation-on-blur
                                required
                                class="pt-1"
                                :id="`input-insurer-${insuredPerson.n}-document-series-number`"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="insuredPerson.document.issueDate"
                                :passportAgeCheck="insuredPerson.datePersonPassport"
                                :isHideMobile="true"
                                :min="insuredPerson.datePersonPassport"
                                :max="passportMaxDate"
                                :id="`input-insurer-${insuredPerson.n}-document-issue-date`"
                            />
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0>
                            <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />

                            <osago-address-dadata
                                :model="insuredPerson.registration"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                                :id="`input-insurer-${insuredPerson.n}-address-registration`"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex shrink pt-0
                                v-if="insuredPersons.length < 4 && insuredPerson.n === insuredPersons.length"
                                class="driverControls"
                        >
                            <a @click="addInsuredPerson(insuredPerson)" id="add-insured-person">
                                <img src="/svg/plus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                Добавить застрахованного
                            </a>
                        </v-flex>
                        <v-flex grow pt-0
                                v-if="insuredPersons.length > 1"
                                class="driverControls"
                        >
                            <a @click="removeInsuredPerson(insuredPerson)" id="remove-insured-person">
                                <img src="/svg/minus.svg" style="width: 21px; height:21px; vertical-align: -5px;"/>
                                Убрать застрахованного
                            </a>
                        </v-flex>
                    </v-layout>

                </v-container>

                <v-container
                    v-if="!hasPolicyHolder"
                    style="max-width: 1240px; padding-left: 30px; padding-right: 30px; padding-bottom: 50px; border-bottom: 1px solid #cecece;"
                >
                    <v-layout>
                        <v-flex xs12 pt-4 pb-0>
                            <h2>Страхователь</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-end>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="policyHolder.lastName"
                                label="Фамилия"
                                id="input-policyholder-lastname"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="policyHolder.firstName"
                                label="Имя"
                                id="input-policyholder-firstname"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg3 py-0>
                            <osago-name
                                v-model="policyHolder.middleName"
                                label="Отчество"
                                optional="true"
                                :noField.sync="policyHolder.noMiddleName"
                                genitiveLabel="отчества"
                                @change="setGender(policyHolder)"
                                id="input-policyholder-middlename"
                            />
                            <osago-gender
                                v-if="policyHolder.noMiddleName"
                                v-model="policyHolder.sex"
                                label="Пол"
                                :noField.sync="policyHolder.sex"
                                id="select-policyholder-no-middlename"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md2 lg2 py-0>
                            <osago-date
                                v-model="policyHolder.birthDate"
                                label="Дата рождения"
                                :max="insurerMaxBirthdayDate"
                                @change="policyHolder.datePersonPassport = getDatePersonPassport(policyHolder)"
                                :isHideMobile="true"
                                id="input-policyholder-birth-date"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout
                        row wrap pt-1
                    >
                        <v-flex xs12 sm6 md3 lg2 py-0>
                            <h4 style="display: inline">Паспорт</h4>

                            <v-text-field
                                v-model="policyHolder.document.seriesNumber"
                                :rules="[rules.required, rules.passport]"
                                @paste="removeSpacesOnPaste($event, policyHolder.document.seriesNumber)"
                                label="Серия и номер"
                                mask="#### ######"
                                return-masked-value
                                validation-on-blur
                                required
                                class="pt-1"
                                id="input-policyholder-document-series-number"
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 py-0 style="align-self: flex-end">
                            <osago-date
                                label="Дата выдачи"
                                v-model="policyHolder.document.issueDate"
                                :passportAgeCheck="policyHolder.datePersonPassport"
                                :isHideMobile="true"
                                :min="policyHolder.datePersonPassport"
                                :max="passportMaxDate"
                                id="input-policyholder-document-issue-date"
                            />
                        </v-flex>
                        <v-flex xs12 md12 lg8 py-0>
                            <h4 style="display: inline; margin: 5px 0 -5px;">Адрес регистрации</h4>
                            <img class="tip-icon" src="/svg/q.svg" alt=""
                                 data-tippy-animateFill="false"
                                 data-tippy-animation="scale"
                                 data-tippy-content="Как в паспорте владельца,<br>на странице прописка"
                            />

                            <osago-address-dadata
                                :model="policyHolder.registration"
                                :checkHouseFiasLevel="true"
                                class="pt-1"
                                id="input-policyholder-address-registration"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container style="max-width: 1240px; padding-left: 30px; padding-right: 30px;">
                    <v-layout row wrap>
                        <v-flex xs12 pt-3 pb-3>
                            <h2 style="display: inline-block;">
                                Условия страхования
                            </h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-flex xs12 sm6 md2 pt-0>
                            <v-select
                                v-model="term"
                                label="Срок"
                                :items="[
                                    { name: '1 год', val: 12 },
                                ]"
                                item-value='val'
                                item-text='name'
                                class="pt-0"
                                id="select-term"
                            ></v-select>
                        </v-flex>

                        <v-flex xs12 sm6 md2 pt-0>
                            <osago-date
                                inputClass="pt-0"
                                label="Дата начала"
                                v-model="dateStart"
                                :yearStarting="false"
                                :min="minDate"
                                id="input-date-start"
                            />
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container style="max-width: 1240px; padding-left: 30px; padding-right: 30px;" class="py-0">
                    <v-layout row wrap>
                        <v-flex pb-2>
                            <h3>Контакты для получения полиса</h3>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-center>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="maskedPhone"
                                :rules="phoneRules"
                                v-mask="'+7 ### ### ## ##'"
                                label="Телефон (для входа в личный кабинет)"
                                validate-on-blur
                                required
                                clearable
                                id="input-phone"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                @keydown.space.prevent
                                v-model="email"
                                :rules="emailRules"
                                label="E-mail (на него придет полис)"
                                validate-on-blur
                                required
                                clearable
                                id="input-email"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md6 lg4 py-0 class="required-email">
                            <p><b>ВАЖНО!</b> Проверьте правильность e-mail, на него придет электронный полис ОСАГО</p>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pt-4>
                        <v-flex xs12 sm6>
                            <v-btn
                                @click="validate"
                                class="submit-button block to-counting"
                                :loading="wait"
                                :disabled="isPayed"
                                id="button-submit"
                            >
                                Рассчитать окончательную стоимость
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <div class="policy-wrapper" style="height: 100px;">
                                Отправляя анкету, соглашаюсь
                                <br>с <a class="policy" target="_blank" href="https://getpolis.ru/osago_policy">политикой
                                обработки персональных данных</a>
                                <br>и даю
                                <a class="policy" target="_blank" href="https://getpolis.ru/soglasie_pdn">
                                    Согласие на обработку персональных данных
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
                <anti-mite-list
                    :companiesList="companiesList"
                    :orderUuid="orderUuid"
                    :isFormChanged="isFormChanged"
                    :isPayed="isPayed"
                    :payedPremium="payedPremium"
                    :userType="user ? user.user_type : null"
                >
                </anti-mite-list>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
import moment from "moment";
import helperMixin from '../mixins/helper';
import _ from "lodash";
export default {
    props: ['data', 'order', 'user'],
    mixins: [helperMixin],

    data: () => ({
        valid: true,
        lastSavedFormData: null,
        preparedFormData: null,
        preview: {
            show: false,
        },
        insuredPersons: [],
        policyHolder: {
            lastName: '',
            firstName: '',
            middleName: '',
            sex: '',
            birthDate: '',
            document: {
                seriesNumber: '',
                issueDate: '',
            },
            registration: {
                region: null,
                string: null,
                fias: null,
                kladr: null,
                flat: null,
                house: null,
                postalCode: null,
                street: null,
            }
        },
        minDate: '',
        term: 12,
        dateStart: null,
        maskedPhone: '',
        phone: '7',
        email: '',

        wait: false,
        uuid: null,
        orderId: null,
        orderUuid: null,
        companiesList: [],
        passportMaxDate: null,
        insurerMaxBirthdayDate: null,
        datePersonMinimal: '',
        isFormChanged: false,
        isPayed: false,
        payedPremium: null,

        rules: {
            required: v => !!v || 'Обязательное поле',
            useTarget: v => v || 'Необходимо подтвердить цель использования авто',
            approvePrivacyPolicy: v => v || 'Необходимо согласиться с политикой обработки персональных данных',
            license: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
            passport: v => /^\d{4} \d{6}$/.test(v) || 'Неверный формат',
            policyNumber: v => v === '' || /^[А-ЯA-Z]{3} \d{10}$/.test(v) || 'Неверный формат'
        },
        phoneRules: [
            v => !!v || 'Обязательное поле',
            v => /^\+7 \d{3} \d{3} \d{2} \d{2}$/.test(v) || 'Неверный формат'
        ],
        emailRules: [
            v => !!v || 'Обязательное поле',
            v => !(/[А-ЯЁа-яё\s]/i.test(v)) || 'E-mail не должен содержать кириллицу и пробелы',
            v => !(/[_.-]{2}/.test(v)) || 'Email не должен содержать идущие друг за другом знак подчеркивания, точку и минус',
            v => /^[A-Za-z0-9@._-]*$/.test(v) || 'Допустимы только латиница, цифры, "@", "-", "_", "."',
            v => /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,24}\b/.test(v) || 'Неверный формат',
            v => v.length <= 35 || 'E-mail не должен превышать 35 символов',
        ],
    }),

    created: async function () {
        const data = JSON.parse(window.atob(this.data));
        const order = JSON.parse(window.atob(this.order));
        this.passportMaxDate = moment().format('YYYY-MM-DD');
        this.insurerMaxBirthdayDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
        if (data !== null && data.data && data.data.uuid) {
            window.history.pushState(null, null, '/antimite/' + data.data.uuid);
            window.location.replace('/antimite/' + data.data.uuid);
        } else {
            if (order.id) {
                this.orderId = order.id;
            }

            if (order.uuid) {
                this.orderUuid = order.uuid;
            }

            if (order.form_data) {
                this.loadFormData(order.form_data)
            }

            if (!order.form_data) {
                this.addInsuredPerson();
                this.insuredPersons[0].isPolicyHolder = true;
                if (this.user && (this.user.email || this.user.phone)) {
                    this.email = this.user.email ? this.user.email : '';
                    this.phone = this.user.phone ? this.user.phone.replace(/\D/g, '') : '';
                }
            }

            if (order.status) {
                const statuses = ['WaitingPayment', 'Payed', 'PdfDownloaded'];
                this.isPayed = statuses.includes(order.status);
                this.payedPremium = order.premium;
            }
        }

        this.minDate = moment().add(6, 'days').format('YYYY-MM-DD');
        this.maskedPhone = '+' + this.phone;

        this.getResults();

        this.autoSaveOn(3000);
    },

    methods: {
        addInsuredPerson() {
            this.insuredPersons.push({
                n: this.insuredPersons.length + 1,
                lastName: null,
                firstName: null,
                middleName: null,
                noMiddleName: false,
                sex: null,
                birthDate: null,
                phone: null,
                email: null,
                birthPlace: null,
                document: {
                    seriesNumber: null,
                    issueDate: null,
                    issued: null,
                    departmentCode: null,
                },
                registration: {
                    region: null,
                    string: null,
                    fias: null,
                    kladr: null,
                    flat: null,
                    house: null,
                    postalCode: null,
                    street: null,
                },
                isPolicyHolder: false,
            });
        },

        removeInsuredPerson(insuredPerson) {
            this.$delete(this.insuredPersons, insuredPerson.n - 1)

            this.insuredPersons = this.insuredPersons.map(function (person, index) {
                person.n = index + 1;
                return person;
            });
        },

        insuredPersonsIsPolicyHolderChange(val) {
            this.insuredPersons = this.insuredPersons.map(insuredPerson => {
                if (insuredPerson.n !== val.n) {
                    insuredPerson.isPolicyHolder = false;
                }
                return insuredPerson;
            });
        },

        setGender(insuredPerson) {
            if (insuredPerson.middleName) {
                insuredPerson.sex = insuredPerson.middleName.endsWith('а') ? 'Женский' : 'Мужской';
            }
        },

        setPersonBirthday(insuredPerson) {
            if (insuredPerson.birthDate) {
                const [year, month, day] = insuredPerson.birthDate.split('-');
                const datePersonPassport = `${parseInt(year) + 14}-${month}-${day}`;
                return { datePersonPassport: datePersonPassport };
            }
        },

        getDatePersonPassport(insuredPerson) {
            let dates = this.setPersonBirthday(insuredPerson);
            return dates ? dates.datePersonPassport : this.datePersonMinimal;
        },

        unmaskPhone(phone) {
            return phone ? phone.match(/[0-9]+/g, '').join('') : phone;
        },

        validate() {
            if (!this.$refs.form.validate()) {
                this.$nextTick(() => {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
                return;
            }

            if (!this.hasPolicyHolder) {
                const { firstName, lastName, middleName, birthDate } = this.policyHolder;
                const duplicatePerson = this.insuredPersons.find(person =>
                    person.firstName === firstName &&
                    person.lastName === lastName &&
                    person.middleName === middleName &&
                    person.birthDate === birthDate
                );

                if (duplicatePerson) {
                    PNotify.error(`Найдено совпадение страхователя с застрахованным: ${duplicatePerson.lastName} ${duplicatePerson.firstName} ${duplicatePerson.middleName}. Пометьте страхователя.`);
                    this.companiesList = [];
                    return;
                }
            }

            this.prepareFormData();
            this.update(this.preparedFormData);
            this.submit();
        },

        prepareFormData() {
            if (this.preparedFormData == null) {
                this.preparedFormData = {};
            }

            if (this.hasPolicyHolder) {
                const policyHolder = this.insuredPersons.find(person => person.isPolicyHolder);

                if (policyHolder) {
                    this.preparedFormData.policyHolder = {
                        lastName: policyHolder.lastName,
                        firstName: policyHolder.firstName,
                        middleName: policyHolder.middleName,
                        hasMiddleName: !policyHolder.noMiddleName,
                        sex: policyHolder.sex,
                        birthDate: policyHolder.birthDate,
                        phone: this.phone,
                        email: this.email,
                        birthPlace: policyHolder.registration ? policyHolder.registration.city : '',
                        document: {
                            seria: policyHolder.document.seriesNumber ? policyHolder.document.seriesNumber.split(' ')[0] : '',
                            number: policyHolder.document.seriesNumber ? policyHolder.document.seriesNumber.split(' ')[1] : '',
                            issueDate: policyHolder.document.issueDate,
                            issued: 'МВД РФ',
                            departmentCode: '771-001',
                        },
                        registration: {
                            region: policyHolder.registration ? policyHolder.registration.region : '',
                            string: policyHolder.registration ? policyHolder.registration.search : '',
                            fias: policyHolder.registration ? policyHolder.registration.fias : '',
                            kladr: policyHolder.registration ? policyHolder.registration.kladr : '',
                            flat: policyHolder.registration ? policyHolder.registration.flat : '',
                            house: policyHolder.registration ? policyHolder.registration.house : '',
                            postalCode: policyHolder.registration ? policyHolder.registration.postalCode : '',
                            street: policyHolder.registration ? policyHolder.registration.street : '',
                        },
                    }
                }
            } else {
                this.preparedFormData.policyHolder = {
                    lastName: this.policyHolder.lastName,
                    firstName: this.policyHolder.firstName,
                    middleName: this.policyHolder.middleName,
                    hasMiddleName: !this.policyHolder.noMiddleName,
                    sex: this.policyHolder.sex,
                    birthDate: this.policyHolder.birthDate,
                    phone: this.phone,
                    email: this.email,
                    birthPlace: this.policyHolder.registration ? this.policyHolder.registration.city : '',
                    document: {
                        seria: this.policyHolder.document.seriesNumber ? this.policyHolder.document.seriesNumber.split(' ')[0] : '',
                        number: this.policyHolder.document.seriesNumber ? this.policyHolder.document.seriesNumber.split(' ')[1] : '',
                        issueDate: this.policyHolder.document.issueDate,
                        issued: 'МВД РФ',
                        departmentCode: '771-001',
                    },
                    registration: {
                        region: this.policyHolder.registration ? this.policyHolder.registration.region : '',
                        string: this.policyHolder.registration ? this.policyHolder.registration.search : '',
                        fias: this.policyHolder.registration ? this.policyHolder.registration.fias : '',
                        kladr: this.policyHolder.registration ? this.policyHolder.registration.kladr : '',
                        flat: this.policyHolder.registration ? this.policyHolder.registration.flat : '',
                        house: this.policyHolder.registration ? this.policyHolder.registration.house : '',
                        postalCode: this.policyHolder.registration ? this.policyHolder.registration.postalCode : '',
                        street: this.policyHolder.registration ? this.policyHolder.registration.street : '',
                    },
                }
            }

            this.preparedFormData.insuredPersons = this.insuredPersons.map(person => ({
                lastName: person.lastName,
                firstName: person.firstName,
                middleName: person.middleName,
                hasMiddleName: !person.noMiddleName,
                sex: person.sex,
                birthDate: person.birthDate,
                isPolicyHolder: person.isPolicyHolder
            }));

            this.preparedFormData.dateBegin = this.dateStart;
        },

        loadFormData(formData) {

            if (this.hasPolicyHolder) {
                if (formData.policyHolder) {
                    const policyHolder = formData.policyHolder;
                    this.phone = policyHolder.phone;
                    if (!policyHolder.phone) {
                        this.phone = this.user.phone ? this.user.phone.replace(/\D/g, '') : '';
                    }
                    this.email = policyHolder.email;
                    if (!policyHolder.email) {
                        this.email = this.user.email ? this.user.email : '';
                    }
                    this.insuredPersons[0] = {
                        n: 1,
                        isPolicyHolder: true,
                        lastName: policyHolder.lastName,
                        firstName: policyHolder.firstName,
                        middleName: policyHolder.middleName,
                        noMiddleName: !policyHolder.hasMiddleName,
                        sex: policyHolder.sex,
                        birthDate: policyHolder.birthDate,
                        document: {
                            seriesNumber: `${policyHolder.document.seria} ${policyHolder.document.number}`,
                            issueDate: policyHolder.document.issueDate,
                        },
                        registration: {
                            city: policyHolder.birthPlace,
                            region: policyHolder.registration.region,
                            search: policyHolder.registration.string,
                            fias: policyHolder.registration.fias,
                            kladr: policyHolder.registration.kladr,
                            flat: policyHolder.registration.flat,
                            house: policyHolder.registration,
                            postalCode: policyHolder.registration,
                            street: policyHolder.registration,
                        },
                    }
                }
            } else {
                if (formData.policyHolder) {
                    const policyHolder = formData.policyHolder;
                    this.phone = policyHolder.phone;
                    if (!policyHolder.phone) {
                        this.phone = this.user.phone ? this.user.phone.replace(/\D/g, '') : '';
                    }
                    this.email = policyHolder.email;
                    if (!policyHolder.email) {
                        this.email = this.user.email ? this.user.email : '';
                    }
                    this.policyHolder = {
                        lastName: policyHolder.lastName,
                        firstName: policyHolder.firstName,
                        middleName: policyHolder.middleName,
                        noMiddleName: !policyHolder.hasMiddleName,
                        sex: policyHolder.sex,
                        birthDate: policyHolder.birthDate,
                        document: {
                            seriesNumber: `${policyHolder.document.seria} ${policyHolder.document.number}`,
                            issueDate: policyHolder.document.issueDate,
                        },
                        registration: {
                            city: policyHolder.birthPlace,
                            region: policyHolder.registration.region,
                            search: policyHolder.registration.string,
                            fias: policyHolder.registration.fias,
                            kladr: policyHolder.registration.kladr,
                            flat: policyHolder.registration.flat,
                            house: policyHolder.registration,
                            postalCode: policyHolder.registration,
                            street: policyHolder.registration,
                        },
                    }
                }
            }

            if (formData.insuredPersons) {
                const policyHolder = formData.policyHolder;

                this.insuredPersons = formData.insuredPersons.map((person, index) => ({
                    n: index + 1,
                    isPolicyHolder: person.isPolicyHolder,
                    lastName: person.lastName,
                    firstName: person.firstName,
                    middleName: person.middleName,
                    noMiddleName: !person.hasMiddleName,
                    sex: person.sex,
                    birthDate: person.birthDate,
                    document: person.isPolicyHolder ? {
                        seriesNumber: `${policyHolder.document ? policyHolder.document.seria : ''} ${policyHolder.document ? policyHolder.document.number : ''}`,
                        issueDate: policyHolder.document ? policyHolder.document.issueDate : '',
                    } : {
                        seriesNumber: '',
                        issueDate: '',
                    },
                    registration: person.isPolicyHolder ? {
                        city: policyHolder.birthPlace,
                        region: policyHolder.registration ? policyHolder.registration.region : '',
                        search: policyHolder.registration ? policyHolder.registration.string : '',
                        fias: policyHolder.registration ? policyHolder.registration.fias : '',
                        kladr: policyHolder.registration ? policyHolder.registration.kladr : '',
                        flat: policyHolder.registration ? policyHolder.registration.flat : '',
                        house: policyHolder.registration ? policyHolder.registration.house : '',
                        postalCode: policyHolder.registration ? policyHolder.registration.postalCode : '',
                        street: policyHolder.registration ? policyHolder.registration.street : '',
                    } : {
                        city: '',
                        region: '',
                        search: '',
                        fias: '',
                        kladr: '',
                        flat: '',
                        house: '',
                        postalCode: '',
                        street: '',
                    },
                }));
            }

            this.dateStart = formData.dateBegin;
            this.$nextTick(() => {
                this.isFormChanged = false;
            });
        },

        autoSaveOn(timeout) {
            let that = this;
            this.autoSaveInterval = setInterval(function () {
                that.prepareFormData();

                if (that.lastSavedFormData == null) {
                    that.lastSavedFormData = _.cloneDeep(that.preparedFormData);
                    that.isFormChanged = false;
                    return;
                }
                if (!_.isEqual(that.lastSavedFormData, that.preparedFormData)) {

                    that.update(that.preparedFormData);
                    that.lastSavedFormData = _.cloneDeep(that.preparedFormData);

                }
            }, timeout);
        },

        update(formData) {
            axios.post(`/antimite/order/update`, { form_data: formData, order_id: this.orderId})
                .then(response => {
                })
                .catch(error => {
                    console.log(error);
                });
        },

        submit() {
            this.isFormChanged = false;
            this.wait = true;

            Promise.allSettled([
                axios.get('/antimite/' + this.orderUuid + '/calculate/rosgosstrah'),
                axios.get('/antimite/' + this.orderUuid + '/calculate/absolute'),
                axios.get('/antimite/' + this.orderUuid + '/calculate/soglasie'),
            ])
                .then(results => {
                    this.wait = false;

                    const rosgosstrahData = results[0].status === 'fulfilled' ? results[0].value.data.data || [] : [];
                    const absoluteData = results[1].status === 'fulfilled' ? results[1].value.data.data || [] : [];
                    const soglasieData = results[2].status === 'fulfilled' ? results[2].value.data.data || [] : [];

                    console.log('Rosgosstrah Data:', rosgosstrahData);
                    console.log('Absolute Data:', absoluteData);
                    console.log('Soglasie Data:', soglasieData);

                    this.companiesList = [...rosgosstrahData, ...absoluteData, ...soglasieData];

                    for (let i = 0; i < this.companiesList.length; i++) {
                        Vue.set(this.companiesList[i], 'showMore', false);
                        Vue.set(this.companiesList[i], 'paymentLoading', false);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.wait = false;
                });
        },

        getResults() {
            this.wait = true;

            axios.get('/antimite/' + this.orderUuid + '/results')
                .then(response => {
                    if (response && response.data) {
                        this.wait = false;
                        this.companiesList = response.data.data;
                        for (let i = 0; i < this.companiesList.length; i++) {
                            Vue.set(this.companiesList[i], 'showMore', false)
                        }
                        for (let i = 0; i < this.companiesList.length; i++) {
                            Vue.set(this.companiesList[i], 'paymentLoading', false)
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.wait = false;
                })
                .finally(() => {
                    this.wait = false;
                });
        }
    },

    watch: {
        maskedPhone(val) {
            const char = val.charAt(0);
            let that = this;
            if (val.length === 1 && (char === '8' || char === '7' || !/\d/.test(char))) {
                this.$nextTick(function() {
                    that.maskedPhone = '+7 ';
                });
            }
            this.$nextTick(function() {
                that.phone = that.unmaskPhone(that.maskedPhone);
            });
        },
        insuredPersons: {
            deep: true,
            handler(newVal) {
                this.isFormChanged = true;
            }
        },
        dateStart() {
            this.isFormChanged = true;
        },
        phone() {
            this.isFormChanged = true;
        },
        email() {
            this.isFormChanged = true;
        }
    },
    computed: {
        hasPolicyHolder() {
            return this.insuredPersons.some(person => person.isPolicyHolder);
        }
    },
}
</script>

<style scoped lang="scss">
.header-part {
    &__title {
        h1 {
            font-family: 'SFPro', 'Arial', 'sans-serif';
            font-size: 65px;
            color: #000000;
            line-height: 1.2;
            font-weight: 700;
        }

        .header-link {
            font-family: 'SFPro', 'Arial', 'sans-serif';
            display: block;
            padding: 24px 0;
            color: #00ba57 !important;
            text-decoration: underline;
        }
    }
}

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 100px;
    background-color: #00ba57 !important;;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.submit-button >>> .v-btn__content {
    white-space: normal;
    padding: 0 50px;
    line-height: 1.1;
}

.policy-wrapper {
    text-align: left;
    display: table-cell;
    vertical-align: middle;
}

.required-email {
    padding: 0;
}

h2 {
    font-size: 30px;
}

h3 {
    font-weight: 500;
}

</style>



// WEBPACK FOOTER //
// resources/js/components/AntiMite.vue